import {
  getPrivacyFieldPrivateOption,
  getPrivacyFieldPublicOption,
} from '../../LabelForm.utils'

export function getPrivacyFieldOptions(t) {
  return [getPrivacyFieldPublicOption(t), getPrivacyFieldPrivateOption(t)]
}
